export function IsWithin(
    element : DOMRect,
    container : DOMRect,
    allowOverlap ?: boolean
) : boolean
{
    const allow = allowOverlap !== undefined ? allowOverlap : false;

    if ( allow && (
        /* Does container left or right edge pass through element? */
        (element.left < container.left && element.right > container.left) ||
        (element.left < container.right && element.right > container.right) ||
        /* Does container top or bottom edge pass through element? */
        (element.top < container.top && element.bottom > container.top) ||
        (element.top < container.bottom && element.bottom > container.bottom))) {

        return true;
    }

    /* 
    If boundaries of element fully contained inside bounday of
    container, classify this as containment of element in container
    */
    if (
        element.left >= container.left &&
        element.top >= container.top &&
        element.bottom <= container.bottom &&
        element.right <= container.right
    ) {
        return true
    }

    return false;
}